export var ChargesForDamagedMissingItemsIA = function ChargesForDamagedMissingItemsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "nIK7TZ",
        defaultMessage: [{
          "type": 0,
          "value": "Charges for damaged or missing items"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "5P7k5e",
        defaultMessage: [{
          "type": 0,
          "value": "For orders placed using net 60 payment terms, any reported items will be removed from your original invoice. For orders that were already charged on shipment, we’ll refund the card on file for the amount of the reported items."
        }]
      }), strictLocalize({
        id: "g05TNU",
        defaultMessage: [{
          "type": 0,
          "value": "If you choose to replace items, a new order will be created with these replacements. You’ll be charged for replacement items separately on your new invoice due date, once the replacement order ships."
        }]
      }), strictLocalize({
        id: "2RyUSl",
        defaultMessage: [{
          "type": 0,
          "value": "For any other questions, please contact us."
        }]
      })];
    }
  };
};